import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';

import { Organization } from '../../models/Organization';
import { ErrorTypes } from '../../types/backendResponses/ErrorTypes';

export const useGetOrganization = (expectedErrors?: ErrorTypes[]) => {
  const { callAPI, ...state } = useAPI<Organization>({ method: 'GET' }, expectedErrors);

  const action = async (): Promise<boolean> => {
    try {
      await callAPI(buildApiUrl('organization'));
      return true;
    } catch (error) {
      return false;
    }
  };

  return { action, ...state };
};
